import {logger} from 'yougile-util'
import {Events} from '../events'

export const browserInitEvents = () => {
  const checkKeys = (e: KeyboardEvent) => {
    Events.shiftPressed = e.shiftKey
    Events.altPressed = e.altKey
    Events.ctrlPressed = e.ctrlKey
    Events.metaPressed = e.metaKey
  }
  document.addEventListener('keydown', checkKeys)
  document.addEventListener('keyup', checkKeys)

  document.addEventListener('keydown', (e: KeyboardEvent) => {
    Events.forEachCurrent((i: Events) => {
      if (i.onKeyDown) {
        try {
          i.onKeyDown(e)
        } catch (err) {
          logger.error(err)
        }
      }
      return true
    })
  })

  document.addEventListener('keyup', (e: KeyboardEvent) => {
    Events.forEachCurrent((i: Events) => {
      if (i.onKeyUp) {
        try {
          i.onKeyUp(e)
        } catch (err) {
          logger.error(err)
        }
      }
      return true
    })
  })

  document.addEventListener('click', (e: MouseEvent) => {
    Events.forEachCurrent((i: Events) => {
      if (i.onClick) {
        try {
          i.onClick(e)
        } catch (err) {
          logger.error(err)
        }
      }
      return true
    })
  })
}
